/* eslint-disable tailwindcss/no-custom-classname */

import { forwardRef } from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

import { Text, TextProps } from '../Text/Text';

export type AccordionDescriptionProps = Omit<
  TextProps<'p'>,
  'size' | 'variant' | '__orbitStyleConfig'
>;

export const AccordionDescription = forwardRef<AccordionDescriptionProps, 'p'>(
  ({ className, ...props }, ref) => {
    return (
      <Text
        {...props}
        ref={ref}
        className={classnames('orbit-accordion__description', className)}
        variant="subtitle"
      />
    );
  },
);
